var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSideStatement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 1.5h13v15.707l-1.5 1.5-1.5-1.5-1.049 1.05-.002.001-.002.002-.03.03-.023.024h-.002l-.007.008-.01.01-.001.001-.001.001-.002.002-.002.003-.003.003h-.001l-.001.002h-.002v.002l-.002.001-.001.001-.001.001-.002.002-.001.001-.001.001-.354.354-1.5-1.5-1.5 1.5-1.5-1.5-1.5 1.5-1.5-1.5-1 1zm1 14.293 1.5 1.5 1.5-1.5 1.5 1.5 1.5-1.5 1.5 1.5 1.5-1.5 1.5 1.5.5-.5V2.5h-11zm6-10.293V4h-1v1.5a2 2 0 1 0 0 4h1a1 1 0 1 1 0 2h-3v1h2V14h1v-1.5a2 2 0 1 0 0-4h-1a1 1 0 0 1 0-2H12v-1z",
  clipRule: "evenodd"
})));
export default SvgSideStatement;